import React from 'react'

type Props = {
  accountId: string
}

const ActivityLogList: React.FC<Props> = ({ accountId }) => {
  return (
    <div className='admin-investor__empty-state'>
      Activity log is not available yet for investor {accountId}.
    </div>
  )
}

export default ActivityLogList

